import AppRouteData from '@/models/app-route-data'
import AppLoader from '@/app-loader'

const state = {
  appRouteData: new AppRouteData(),
  mapReady: false,
  cleanMap: false,
  openSettings: false,
  openAbout: false,
  dangeruousPoints:'4',
  AccidentHostpot: []
}

const getters = {
  appRouteData: state => {
    return state.appRouteData
  },
  testp: state => {
    return state.test
  },
  mapReady: state => {
    return state.mapReady
  },
  cleanMap: state => {
    return state.cleanMap
  },
  openSettings: state => {
    return state.openSettings
  },
  openAbout: state => {
    return state.openAbout
  },
  dangeruousPoints: state => {
    return state.dangeruousPoints
  },
  AccidentHostpot : state => {
    return state.AccidentHostpot
  }
}

const mutations = {
  appRouteData: (state, value) => {
    state.appRouteData = value
    AppLoader.getInstance().appHooks.run('appRouteDataChanged', state.appRouteData)
  },
  testp: (state, value) => {
    state.test = value
    AppLoader.getInstance().appHooks.run('testp', state.test)
  },
  mapReady: (state, value) => {
    state.mapReady = value
  },
  cleanMap: (state, value) => {
    state.cleanMap = value
  },
  openAbout: (state, value) => {
    state.openAbout = value
  },
  openSettings: (state, value) => {
    state.openSettings = value
  },
  dangeruousPoints: (state, value) => {
    state.dangeruousPoints = value
  },
  AccidentHostpot : (state,value) => {
    state.AccidentHostpot = value
  }
}


const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
